import treatmentObjectFragment from "../fragments/treatmentObject";

const treatmentAdjustmentQuery1 = `treatmentAdjustments1[]
${treatmentObjectFragment}
`;

export default treatmentAdjustmentQuery1;
